import { createAction, props } from '@ngrx/store';
import { User } from '../../models/user.model';

export const login = createAction(
  '[Auth] Login'
);

export const loginSuccess = createAction(
  '[Auth] Login Success',
  props<{ user: User }>()
);

export const loginFail = createAction(
  '[Auth] Login Fail',
  props<{ error: any }>()
);

export const logout = createAction('[Auth] Logout');

export const updateUsername = createAction(
  '[Auth] Update Username',
  props<{ username: string }>()
);

export const updatePassword = createAction(
  '[Auth] Update Password',
  props<{ password: string }>()
);

